import React from 'react';

import { IdenfyLivenessCheckResult } from '@tf/shared';
import { createStyles, Stack } from '@tf/ui';

import { useUnitLivenessChecks } from '../../../../api/livenessCheck';
import { useSegmentContext } from '../../../../hooks';
import type { DefaultInputProps } from '../../types';

const useStyles = createStyles(() => ({
	label: {
		fontWeight: 500,
		fontSize: '14px',
	},
}));

export const LivenessCheck: React.FC<DefaultInputProps> = () => {
	const { classes } = useStyles();

	// Important: we expect that LivenessCheck field is placed inside a segment tied to entity
	// and thus identity.graphId = entity graph node id
	const { identity } = useSegmentContext();
	const livenessChecks = useUnitLivenessChecks(identity.graphId);

	if (!livenessChecks.data || livenessChecks.data.length === 0) {
		return null;
	}

	return (
		<Stack gap="0.5rem">
			<span className={classes.label}>Liveness verification</span>
			{livenessChecks.data.map((livenessCheck) => (
				<IdenfyLivenessCheckResult
					key={livenessCheck.id}
					state={livenessCheck.meta.state}
					response={livenessCheck.data.response}
					attachments={livenessCheck.attachments.map((a) => a.object)}
				/>
			))}
		</Stack>
	);
};
